import React, { useState, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { faqList } from '../../redux/slice/FaqList';

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(0);
    const dispatch = useDispatch();
    const faqData = useSelector((state) => state?.faqList?.data) || [];

    useEffect(() => {
        dispatch(faqList());
    }, []);

    const toggle = (index) => {
        setOpenIndex((prev) => (prev === index ? -1 : index));
    };

    return (
        <section className="faq-section" style={styles.section}>
            <div className="container">
                <h2 className="offer-title text-center" data-aos="flip-up" style={styles.title}>
                    Frequently Asked Questions
                </h2>
                <p className="text-center" style={styles.subtitle}>
                    Everything you need to know about the platform. Can’t find the answer you’re looking for?
                </p>

                <div style={styles.list}>
                    {faqData.filter((item) => item.status === 'Active').map((item, index) => {
                        const isOpen = openIndex === index;
                        return (
                            <div
                                key={item._id || index}
                                data-aos="fade-up"
                                data-aos-delay={100 * index}
                                style={{
                                    ...styles.item,
                                    boxShadow: isOpen
                                        ? '0 12px 30px rgba(102, 126, 234, 0.18)'
                                        : '0 2px 10px rgba(0, 0, 0, 0.05)',
                                    borderColor: isOpen ? '#667eea' : '#e5e7eb'
                                }}
                            >
                                <button
                                    type="button"
                                    onClick={() => toggle(index)}
                                    style={styles.question}
                                    aria-expanded={isOpen}
                                >
                                    <span style={styles.questionText}>{item.title}</span>
                                    <FaChevronDown
                                        style={{
                                            ...styles.chevron,
                                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                            color: isOpen ? '#667eea' : '#9ca3af'
                                        }}
                                    />
                                </button>
                                <div
                                    style={{
                                        ...styles.answerWrap,
                                        maxHeight: isOpen ? '320px' : '0',
                                        opacity: isOpen ? 1 : 0
                                    }}
                                >
                                    <p style={styles.answerText}>{item.desc}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

const styles = {
    section: {
        padding: '20px 0 80px',
        background: 'linear-gradient(180deg, #ffffff 0%, #f5f7ff 100%)'
    },
    title: {
        marginBottom: '12px'
    },
    subtitle: {
        color: '#6b7280',
        maxWidth: '640px',
        margin: '0 auto 48px',
        fontSize: '16px',
        lineHeight: 1.6
    },
    list: {
        maxWidth: '820px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    item: {
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '14px',
        overflow: 'hidden',
        transition: 'box-shadow 0.3s ease, border-color 0.3s ease'
    },
    question: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        padding: '20px 24px',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left'
    },
    questionText: {
        fontSize: '17px',
        fontWeight: 600,
        color: '#1f2937'
    },
    chevron: {
        flexShrink: 0,
        fontSize: '16px',
        transition: 'transform 0.3s ease, color 0.3s ease'
    },
    answerWrap: {
        overflow: 'hidden',
        transition: 'max-height 0.35s ease, opacity 0.35s ease'
    },
    answerText: {
        margin: 0,
        padding: '0 24px 22px',
        color: '#6b7280',
        fontSize: '15px',
        lineHeight: 1.7
    }
};

export default FAQ;
